import type { SxProps, Theme } from "@mui/material";

export const inputRangeSx: SxProps<Theme> = {
  width: "100%",
  "& .MuiInputBase-root": {
    height: 32,
    fontSize: 16,
    paddingLeft: 0.8,
  },
  ".MuiInputAdornment-root": {
    marginRight: 0.3,
    "& > p": {
      fontSize: 13,
    },
    "& .MuiInputBase-root": {
      fontSize: 13,
      color: "text.secondary",
    },
    "& .MuiSelect-icon": {
      fontSize: 18,
      top: "calc(50% - 9px)",
    },
  },
};
